import { UseMutationResult, useMutation } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { ICustomer } from "../../sdk/types";
import { api } from "../../sdk/utils";

export interface ICreateCustomerParameter {
    firstName: string;
    lastName: string;
    emailAddress: string;
    phoneNumber: string;
}

export const useCreateCustomer = (): UseMutationResult<
    ICustomer,
    unknown,
    ICreateCustomerParameter
> => {
    const auth = useAuth();
    return useMutation({
        mutationFn: async (parameters: ICreateCustomerParameter) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot create customer group without authorization token.",
                );
            }

            return await api.Customer.create({
                ...parameters,
                token: auth.token,
            });
        },
    });
};
